import React from 'react';
import { connect } from 'dva';
import styles from './ModalView.module.scss';
import noop from 'lodash-es/noop';
import PropTypes from 'prop-types';
// import { CSSTransitionGroup } from 'react-transition-group';

function ModalView(props) {
  const topOfStack = props.modalStack[0];
  let shouldShow = '';
  let CurModal = null;
  let curProps = null;
  let dismissable = true;
  if (topOfStack) {
    shouldShow = styles.showBackground;
    CurModal = topOfStack.component;
    curProps = topOfStack.props;
    dismissable =
      topOfStack.dismissable != null ? topOfStack.dismissable : true;
  }

  const closeModal = (e) => {
    e.preventDefault();
    e.stopPropagation();

    props.dispatch({
      type: 'modals/close',
    });
  };

  /*
    #TODO: Add animation for modal show and hide.
    -- TJC - July 26, 2021
  */
  return (
    <div
      className={`${styles.container} ${shouldShow}`}
      onClick={dismissable ? closeModal : noop}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={styles.modalContainer}
      >
        {/* <CSSTransitionGroup
          transitionName="toast"
          transitionEnterTimeout={200}
          transitionExitTimeout={200}
        > */}
          {CurModal ? <CurModal {...curProps} /> : null}
        {/* </CSSTransitionGroup> */}
      </div>
    </div>
  );
}

ModalView.propTypes = {
  modalStack: PropTypes.array,
};

export default connect((model) => {
  return {
    modalStack: model.modals.stack,
  };
})(ModalView);
